import React from 'react';
import BatchCoordinateInput from './BatchCoordinateInput';

export default function BatchConvertPanel({
  batchInput,
  setBatchInput,
  handleBatchConvert,
  loading,
  batchResult,
  handleExport
}) {
  return (
    <div>
      <BatchCoordinateInput value={batchInput} onChange={setBatchInput} />
      <button
        onClick={handleBatchConvert}
        disabled={loading}
        style={{
          padding: '10px 20px',
          background: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1
        }}
      >
        {loading ? '批量转换中...' : '批量转换'}
      </button>

      {batchResult && (
        <div style={{ marginTop: 20, padding: 15, background: '#f5f5f5', borderRadius: '4px' }}>
          <h4>批量转换结果</h4>
          {batchResult.error ? (
            <div style={{ color: 'red' }}>{batchResult.error}</div>
          ) : (
            <div>
              <div><strong>总计:</strong> {batchResult.summary.total}</div>
              <div><strong>成功:</strong> {batchResult.summary.success}</div>
              <div><strong>失败:</strong> {batchResult.summary.failed}</div>

              <div style={{ marginTop: 10, maxHeight: 200, overflowY: 'auto' }}>
                {batchResult.results.map((item, index) => (
                  <div key={index} style={{ marginBottom: 10, padding: 10, background: '#fff', borderRadius: '3px' }}>
                    {item.error ? (
                      <div style={{ color: 'red' }}>错误: {item.error}</div>
                    ) : (
                      <div>
                        <div><strong>原始:</strong> {item.original}</div>
                        <div><strong>转换后:</strong> {item.converted.lat}, {item.converted.lng}</div>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {batchResult.summary.success > 0 && (
                <button
                  onClick={() => handleExport(
                    batchResult.results.filter(r => !r.error).map(r => r.converted),
                    'CSV',
                    'batch_coordinates_export'
                  )}
                  style={{ marginTop: 10, padding: '8px 16px', background: '#ff9800', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                  导出成功结果
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
